var _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsvSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_25607",
    "data-name": "Group 25607",
    transform: "translate(-454 -1104)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Document_36dp_Copy_3",
    "data-name": "Icon/Document/36dp Copy 3",
    transform: "translate(454 1104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Document",
    "data-name": "Icon/Document"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 36,
    height: 36,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M27,33H8.985A3,3,0,0,1,6,30V6A3,3,0,0,1,9,3H21l9,9V30A3,3,0,0,1,27,33ZM21,4.75h0V10.5A1.5,1.5,0,0,0,22.5,12h5.75L21,4.75Z",
    fill: "#217346"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "X",
    transform: "translate(-165.55 613.882)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25605",
    "data-name": "Group 25605",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13991",
    "data-name": "Path 13991",
    d: "M627.736,511.125a3.773,3.773,0,0,1,3.718-4.1,3.271,3.271,0,0,1,2.375,1.019l-.984,1.128a1.835,1.835,0,0,0-1.343-.54c-1.031,0-1.859.912-1.859,2.423,0,1.559.732,2.459,1.823,2.459a1.981,1.981,0,0,0,1.5-.649l.972,1.1a3.245,3.245,0,0,1-2.531,1.151C629.415,515.118,627.736,513.764,627.736,511.125Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13992",
    "data-name": "Path 13992",
    d: "M634.252,513.979l.983-1.211a3.118,3.118,0,0,0,1.967.744c.708,0,1.032-.264,1.032-.684,0-.456-.42-.6-1.1-.876l-.995-.431a2.273,2.273,0,0,1-1.583-2.135,2.57,2.57,0,0,1,2.83-2.363,3.749,3.749,0,0,1,2.531.971l-.972,1.212a2.783,2.783,0,0,0-1.559-.576c-.575,0-.947.228-.947.636,0,.456.492.611,1.187.887l.972.4a2.139,2.139,0,0,1,1.547,2.123c0,1.307-1.092,2.446-2.974,2.446A4.162,4.162,0,0,1,634.252,513.979Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13993",
    "data-name": "Path 13993",
    d: "M640.444,507.167h1.967l.852,3.562c.216.851.383,1.643.611,2.495h.049c.227-.852.4-1.644.611-2.495l.936-3.562h1.894l-2.386,7.808h-2.243Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvSmall);
export default __webpack_public_path__ + "static/media/csv-small.9f1742876401dd5517b5d1095f15e386.svg";
export { ForwardRef as ReactComponent };